import {TOGGLE_LANGUAGE_LIST, 
        TOGGLE_PROGLANG_LIST, 
        SELECT_PROGLANG, 
        TOGGLE_SIDE_NAV, 
        TOGGLE_STEPS_LIST,
        TOGGLE_RESPONSES_LIST,
        SELECT_RESPONSE,
        UPDATE_PREV_SUCC_STEP,
        SELECT_FEATURE,
        SELECT_MODE,
        SELECT_STEP,
        UPDATE_AMOUNT,
        UPDATE_API_TOKEN,
        UPDATE_CURRENCY,
        UPDATE_EXPDATE,
        UPDATE_ORDER_ID,
        UPDATE_PAN,
        UPDATE_STORE_ID,
        UPDATE_TXN_NUMBER,
        UPDATE_ECR_NUMBER,
        UPDATE_CAVV,UPDATE_ECI,
        UPDATE_CHALLENGE_DATA,
        UPDATE_CHALLENGE_URL,
        UPDATE_CRES,
        UPDATE_NOTIFICATION_URL,
        RESET_CONFIGURATION,
        CLEAR_HISTORY,
        UPDATE_ON_EDIT_ID,
        _COMMON,
        _3DS2,
        _MCP,
        _BASIC_TRANSACTIONS,
        _RECURRING_BILLING,
        _VAULT,
        _VAULTFINANCIAL,
        _MCO,
    } from './types'

import store from '../store';

import TransactionsSteps from '../constants/transactions/steps'
import RecurringSteps from '../constants/recurring/steps'
import VaultSteps from '../constants/vault/steps'
import VaultFinancialSteps from '../constants/vaultFinancial/steps'
import MCPSteps from '../constants/mcp/steps'
import ThreeDSTwoSteps from '../constants/3DS2/steps'
import MCOSteps from '../constants/checkout/steps'

const progs = ['dotnet', 'java', 'php'];

export const toggleLanguageList = () => dispatch => {
    dispatch({ feature: _COMMON, type: TOGGLE_LANGUAGE_LIST });
}

export const toggleProgLangList = () => dispatch => {
    dispatch({ feature: _COMMON, type: TOGGLE_PROGLANG_LIST });
}

export const selectProgLang = (progLangId) => dispatch => {
    dispatch({ feature: _COMMON, type: SELECT_PROGLANG, payload: progLangId });
    const { featureId, stepName } = window.history.state;
    const currentMode = store.getState().common.sideNav.mode;
    window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/${currentMode === 'interactive_tool' ? 'tool' : 'guide'}/${progs[progLangId]}`);
}

export const toggleSideNav = () => dispatch => {
    dispatch({ feature: _COMMON, type: TOGGLE_SIDE_NAV });
}

export const toggleStepsList = (featureId) => dispatch => {
    dispatch({ feature: featureId, type: TOGGLE_STEPS_LIST });
}
    
export const toggleResponsesList = (featureId) => dispatch => {
    dispatch({ feature: featureId, type: TOGGLE_RESPONSES_LIST });
}
    
export const selectResponse = ({featureId, responseId}) => dispatch => {
    dispatch({ feature: featureId, type: SELECT_RESPONSE, payload: responseId });
}
    
export const updatePrevSuccStep = ({featureId, stepId}) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_PREV_SUCC_STEP, payload: stepId });
}

export const updateOnEditId = ({featureId, valueId}) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_ON_EDIT_ID, payload: valueId });
}
    
export const resetConfiguration = featureId => dispatch => {
    dispatch({ feature: featureId, type: RESET_CONFIGURATION });
}

export const selectFeature = (featureId) => dispatch => {
    dispatch({ feature: _COMMON, type: SELECT_FEATURE, payload: featureId });
}

export const selectMode = (mode) => dispatch => {
    dispatch({ feature: _COMMON, type: SELECT_MODE, payload: mode });
    const { featureId, stepName } = window.history.state;
    const currentProgId = store.getState().common.progLangList.selection;

    if(mode === 'interactive_tool')
        window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/tool/${progs[currentProgId]}`);
    else
        window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/guide/${progs[currentProgId]}`);
}

export const selectStep = ({ stepId, featureId }) => dispatch => {
    dispatch({ feature: _COMMON, type: SELECT_FEATURE, payload: featureId });
    dispatch({ feature: _COMMON, type: SELECT_STEP, payload: stepId });
    dispatch({ feature: featureId, type: SELECT_STEP, payload: stepId });

    const currentMode = store.getState().common.sideNav.mode;
    const currentProgId = store.getState().common.progLangList.selection;

    switch (featureId) {
        case _BASIC_TRANSACTIONS: {
            const stepName = TransactionsSteps[stepId - 1].name;
            window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/${currentMode === 'interactive_tool' ? 'tool' : 'guide'}/${progs[currentProgId]}`);
            break;
        }
    
        case _MCP: {
            const stepName = MCPSteps[stepId - 1].name;
            if([1, 2, 17, 18, 19].includes(stepId)) {
                dispatch({ feature: _COMMON, type: SELECT_MODE, payload: 'integration_guide' });
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/guide/${progs[currentProgId]}`);
            }
            else {
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/${currentMode === 'interactive_tool' ? 'tool' : 'guide'}/${progs[currentProgId]}`);
            }
            break;
        }
    
        case _VAULTFINANCIAL: {
            const stepName = VaultFinancialSteps[stepId - 1].name;
            if([1,7].includes(stepId)) {
                dispatch({ feature: _COMMON, type: SELECT_MODE, payload: 'integration_guide' });
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/guide/${progs[currentProgId]}`);
            }
            else {
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/${currentMode === 'interactive_tool' ? 'tool' : 'guide'}/${progs[currentProgId]}`);
            }
            break;
        }
    
        case _VAULT: {
            const stepName = VaultSteps[stepId - 1].name;
            if([1, 2, 4, 7, 15, 21].includes(stepId)) {
                dispatch({ feature: _COMMON, type: SELECT_MODE, payload: 'integration_guide' });
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/guide/${progs[currentProgId]}`);
            }
            else {
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/${currentMode === 'interactive_tool' ? 'tool' : 'guide'}/${progs[currentProgId]}`);
            }
            break;
        }
    
        case _3DS2: {
            const stepName = ThreeDSTwoSteps[stepId - 1].name;
            // if step is not interactive
            if([1, 2, 6, 12, 13, 14].includes(stepId)) {
                dispatch({ feature: _COMMON, type: SELECT_MODE, payload: 'integration_guide' });
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/guide/${progs[currentProgId]}`);
            }
            else {
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/${currentMode === 'interactive_tool' ? 'tool' : 'guide'}/${progs[currentProgId]}`);
            }
            break;
        }
    
        case _RECURRING_BILLING: {
            const stepName = RecurringSteps[stepId - 1].name;
            if([1, 4, 5].includes(stepId)) {
                dispatch({ feature: _COMMON, type: SELECT_MODE, payload: 'integration_guide' });
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/guide/${progs[currentProgId]}`);
            }
            else {
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/${currentMode === 'interactive_tool' ? 'tool' : 'guide'}/${progs[currentProgId]}`);
            }
            break;
        }

        case _MCO: {
            const stepName = MCOSteps[stepId - 1].name;
            if(![3, 4, 5, 6].includes(stepId)) {
                dispatch({ feature: _COMMON, type: SELECT_MODE, payload: 'integration_guide' });
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/guide/${progs[currentProgId]}`);
            }
            else {
                window.history.pushState({featureId, stepName}, '', `/livedemo/${featureId}/${stepName}/${currentMode === 'interactive_tool' ? 'tool' : 'guide'}/${progs[currentProgId]}`);
            }
            break;
        }
      
        default:
          break;
    }
}

export const updateAmount = ({ featureId, amount }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_AMOUNT, payload: amount });
}

export const updateApiToken = ({ featureId, apiToken }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_API_TOKEN, payload: apiToken });
}

export const updateCurrency = ({ featureId, currency }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_CURRENCY, payload: currency });
}

export const updateExpDate = ({ featureId, expDate }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_EXPDATE, payload: expDate });
}

export const updateOrderId = ({ featureId, orderId }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_ORDER_ID, payload: orderId });
}

export const updatePan = ({ featureId, pan }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_PAN, payload: pan });
}

export const updateStoreId = ({ featureId, storeId }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_STORE_ID, payload: storeId });
}

export const updateTxnNumber = ({ featureId, txnNumber }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_TXN_NUMBER, payload: txnNumber });
}

export const updateEcrNumber = ({ featureId, ecrNumber }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_ECR_NUMBER, payload: ecrNumber });
}

export const updateCavv = ({ featureId, cavv }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_CAVV, payload: cavv });
}

export const updateEci = ({ featureId, eci }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_ECI, payload: eci });
}

export const updateChallengeData = ({ featureId, data }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_CHALLENGE_DATA, payload: data });
}

export const updateChallengeURL = ({ featureId, url }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_CHALLENGE_URL, payload: url });
}

export const updateCres = ({ featureId, cres }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_CRES, payload: cres });
}

export const updateNotificationUrl = ({ featureId, notification_url }) => dispatch => {
    dispatch({ feature: featureId, type: UPDATE_NOTIFICATION_URL, payload: notification_url });
}

export const resetConfig = (featureId) => dispatch => {
    dispatch({ feature: featureId, type: RESET_CONFIGURATION });
}

export const clearHistory = (featureId) => dispatch => {
    dispatch({ feature: featureId, type: CLEAR_HISTORY });
}